<div class="row justify-content-center overFlowRes" [dir]="this.app.getUserDire()" *ngIf="app?.isPlatformBrowserVar">
    <div *ngIf="mediaExists" class="col-sm-12 col-md-8 col-lg-8 col-xl-8 bg-muted br7 pos-rel">

        <!-- <mat-icon (click)="cancel()" class="cancelBtn mainColor pointer">cancel</mat-icon> -->

        <ngx-slick-carousel class="h-100" #slickModal="slick-carousel" [config]="slideConfigureForDoctor">
            <!-- ngxSlickItem -->

            <div class="h-100" *ngFor="let media of postDetails?.postMedia" ngxSlickItem>

                <div class="d-flex justify-content-center align-items-center h-100 w-100" *ngIf="media?.mediaType == 1">
                    <!-- <app-img-loader [className]="'responsive'" [src]="media?.mediaFilePath"></app-img-loader> -->
                    <img class="responsive-detailed-img" [src]="app?.getImageFile(media?.mediaFilePath)">
                </div>

                <div class="d-flex justify-content-center align-items-center h-100 w-100" *ngIf="media?.mediaType == 2">
                    <video class="responsive-detailed-img" controls>
                        <source [src]="app.getImageFile(media?.mediaFilePath)" type="video/mp4">
                    </video>
                </div>

                <div class="d-flex justify-content-center align-items-center h-100 w-100" *ngIf="media?.mediaType == 3">

                    <div class="card pointer" (click)="urlClicked(urlData?.url)">
                        <img [src]="urlData?.image">
                        <p class="p-3 UrlDesc">{{urlData?.description}}</p>
                    </div>

                </div>

            </div>

        </ngx-slick-carousel>

    </div>
    <div [ngClass]="mediaExists ? 'col-sm-12 col-md-4 col-lg-4 col-xl-4' : 'col-8'">
        <div class="bgWhite p-3 parentClass">
            <div class="overFlowH" #mainCommentsScroll>

                <!-- post header -->
                <div data-aos="fade-up" data-aos-duration="800">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">

                            <!-- <img class="border-less object-cover" [src]="app.getUserImage(postDetails?.creatorPicture)"
                            alt="User Image"> -->

                            <app-img-loader [className]="'postCreator'"
                                [src]="postDetails?.creatorPicture"></app-img-loader>

                            <div class="mx-2 d-flex align-items-start">
                                <div>
                                    <p class="m-0 posterName pointer" (click)="routeToDocProfile(postDetails)">{{postDetails?.creatorName | splitStringToArEn}}</p>
                                    <p class="m-0 posterSpech">{{postDetails?.creatorSpeciality | splitStringToArEn}}
                                    </p>
                                    <p class="m-0 posterSpech">{{postDetails?.createdAt | relativeTime:
                                        app?.languageCode}}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="mx-2">
                            <!-- <mat-icon (click)="editPostPopUp(postDetails?.postId,postDetails?.isMyPost)"
                            class="threeDotsColor pointer">more_vert</mat-icon> -->
                            <!-- settings -->

                            <mat-icon *ngIf="this.app.getUserData()"
                                (click)="editPostPopUp(postDetails?.postId,postDetails?.isMyPost)"
                                class="threeDotsColor pointer mx-2">settings</mat-icon>

                            <!-- *ngIf="mediaExists == false" -->
                            <mat-icon [routerLink]=" '/' + app?.languageCode +'/Tebgram/activity'"
                                class="threeDotsColor pointer">cancel</mat-icon>
                        </div>
                    </div>
                    <p class="postContentP my-2" [ngClass]="postDetails?.textDirection == 'ltr' ? 'ltr1' : 'rtl1'">
                        <span *ngIf="postDetails?.postText?.length < 400">{{postDetails?.postText}}</span>
                        <span *ngIf="postDetails?.postText?.length >= 400">
                            <span *ngIf="!postDetails?.postTextLengthMoreThan400 || postDetails?.postTextLengthMoreThan400 == false">
                                {{postDetails?.postText.slice(0, 400)}}<span class="text-primary mx-2 pointer" (click)="this?.postDetails.postTextLengthMoreThan400 = true">{{ 'social.showMore2' | translate }}</span>
                            </span>
                            <span *ngIf="postDetails?.postTextLengthMoreThan400 == true">{{postDetails?.postText}}</span>
                        </span>
                    </p>
                </div>
                <!-- post header -->

                <!-- post likes etc etc  -->
                <div>
                    <div class="d-flex justify-content-between px-2 my-2" data-aos="fade-up" data-aos-duration="800">

                        <div>


                            <div class="d-block-inline">
                                <div class="d-flex pointer">

                                    <mat-icon (click)="likeDislikePost(postDetails?.postId,postDetails?.iLikedPost)"
                                        class="favColor like-icon" [ngClass]="{'liked': postDetails?.iLikedPost}">
                                        {{postDetails?.iLikedPost ?'favorite' :'favorite_outlined'}}</mat-icon>


                                    <p (click)="likesPopUp(postDetails?.postId,postDetails?.likesCount,'post')"
                                        class="m-0 favNumbers mx-1 d-flex align-items-center">
                                        {{postDetails?.likesCount | likeCount}}</p>
                                </div>
                            </div>

                            <div class="d-block-inline">
                                <div class="d-flex pointer mx-2" (click)="scrollDownMainComments()">
                                    <mat-icon class="commentsColor">chat_bubble_outlined</mat-icon>
                                    <p class="m-0 favNumbers mx-1 d-flex align-items-center">
                                        {{postDetails?.commentsCount}}</p>
                                </div>
                            </div>


                        </div>



                        <div *ngIf="!app?.IsSocialMediaManager">
                            <div class="d-flex pointer" (click)="savePost()">
                                <span class="dotCirIconArrow material-symbols-outlined"><mat-icon
                                        class="arrowIcons like-icon mainColor"
                                        [ngClass]="{'liked': postDetails?.iSavedPost}">{{postDetails?.iSavedPost ?
                                        'bookmark' :
                                        'bookmark_outlined'}}</mat-icon></span>
                            </div>
                        </div>


                    </div>
                </div>
                <!-- post likes etc etc  -->

                <!-- comment Section -->
                <div class="px-3 my-1 py-1" *ngFor="let comment of Comments; let i = index" [@fadeUpAnimation]
                    [ngClass]="comment?.hasComments == true ? 'bg-grey-comments' : ''">
                    <!-- mainCommentsSection -->
                    <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-start">
                            <!-- <img class="border-less-comments object-cover"
                                    [src]="app.getUserImage(comment?.commentedByPicture)" alt="User Image"> -->

                            <app-img-loader [className]="'commentCreator'"
                                [src]="comment?.commentedByPicture"></app-img-loader>

                            <div class="mx-2 d-flex align-items-start">
                                <div>
                                    <p class="m-0 CommentatorName">{{comment?.commentedByName | splitStringToArEn}}</p>
                                    <p class="m-0 posterSpech">{{comment?.commentText}}</p>
                                    <p class="m-0 posterSpech">
                                        <span *ngIf="comment?.likesCount != 0" class="pointer"
                                            (click)="likesPopUp(comment?.commentId,comment?.likesCount,'comment')">{{comment?.likesCount
                                            | likeCount}}
                                            {{ 'social.like' | translate }}</span>
                                        <span (click)="replyToComment(i)"
                                            [ngClass]="{'mx-2': comment?.likesCount != 0 }" class="pointer replyP">{{
                                            'social.reply' | translate }}</span>
                                        <span *ngIf="comment?.commentsCount != 0"
                                            [ngClass]="{'mx-2': comment?.likesCount == 0 }" class="pointer replyPCount"
                                            (click)="showAllSubComments(i,comment?.commentsCount)">•{{comment?.commentsCount}}
                                            {{ 'social.replies' | translate }}</span>

                                        <span class="replyP mx-2">{{comment?.createdAt| relativeTime:
                                            app?.languageCode}}</span>

                                        <span *ngIf="comment?.isMyComment || app?.IsSocialMediaManager"
                                            (click)="deleteComment(comment?.commentId,i,'surface',null)"
                                            class="text-danger pointer">{{ 'social.delete' | translate }}</span>

                                        <!-- <p class="m-0 posterSpech">{{postDetails?.createdAt | relativeTime: app?.languageCode}}</p> -->
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <mat-icon
                                (click)="likeDislikeComment(comment?.iLikedComment,comment?.commentId,i,'surface',null)"
                                [ngClass]="{'liked': comment?.iLikedComment}"
                                class="favColor pointer like-icon">{{comment?.iLikedComment ?
                                'favorite' :'favorite_outlined'}}</mat-icon>
                        </div>
                    </div>
                    <!-- mainCommentsSection -->

                    <!-- addSubComment -->
                    <div *ngIf="comment?.writeSubComment == true" [@fadeUpAnimation]
                        [ngClass]="this.app?.getUserLanguage() == 'en' ? 'plComments-4' : 'prComments-4'">

                        <div class="d-flex justify-content-between align-items-center">
                            <img class="border-less-comments" [src]="app.getUserImage(app?.getUserData()?.picture)"
                                alt="User Image">

                            <mat-form-field class="w-100 feedField h65 px-1" [dir]="this?.app?.getUserDire()"
                                appearance="outline">
                                <input #commentInput [placeholder]=" 'social.typeComment' | translate " type="text"
                                    matInput>
                                <mat-icon (click)="sendSubComment(comment?.commentId,commentInput.value,i)" matSuffix
                                    class="sendIcon"
                                    [ngClass]="this.app?.getUserLanguage() == 'en' ? '' : 'rotate180'">send</mat-icon>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- addSubComment -->

                    <!-- subCommentsSection -->
                    <div *ngIf="comment?.hasComments == true" class="pos-rel"
                        [ngClass]="this.app?.getUserLanguage() == 'en' ? 'plComments-4' : 'prComments-4'">

                        <div *ngIf="comment?.subComments[0] && !comment?.showSubComments" [@fadeUpAnimation]>
                            <div class="d-flex justify-content-between">
                                <div class="d-flex align-items-start">
                                    <!-- <img class="border-less-comments object-cover"
                                            [src]="app.getUserImage(comment?.subComments[0]?.commentedByPicture)"
                                            alt="User Image"> -->

                                    <app-img-loader [className]="'commentCreator'"
                                        [src]="comment?.subComments[0]?.commentedByPicture"></app-img-loader>

                                    <div class="mx-2 d-flex align-items-start">
                                        <div>
                                            <p class="m-0 CommentatorName">
                                                {{comment?.subComments[0]?.commentedByName | splitStringToArEn}}
                                            </p>
                                            <p class="m-0 posterSpech">{{comment?.subComments[0]?.commentText}}</p>
                                            <p class="m-0 posterSpech">
                                                <span
                                                    (click)="likesPopUp(comment?.subComments[0]?.commentId,comment?.subComments[0]?.likesCount,'comment')"
                                                    [ngClass]="{'mx-2': comment?.subComments[0]?.likesCount != 0 }"
                                                    *ngIf="comment?.subComments[0]?.likesCount != 0"
                                                    class="pointer">{{comment?.subComments[0]?.likesCount |
                                                    likeCount}}
                                                    {{ 'social.like' | translate }}</span>

                                                <span class="replyP">{{comment?.subComments[0]?.createdAt|
                                                    relativeTime:
                                                    app?.languageCode}}</span>

                                                <span *ngIf="comment?.subComments[0]?.isMyComment || app?.IsSocialMediaManager"
                                                    (click)="deleteComment(comment?.subComments[0]?.commentId,i,'deep',0)"
                                                    class="text-danger pointer mx-2">{{ 'social.delete' | translate
                                                    }}</span>
                                            </p>
                                        </div>
                                    </div>

                                </div>
                                <div>
                                    <mat-icon
                                        (click)="likeDislikeComment(comment?.subComments[0]?.iLikedComment,comment?.subComments[0]?.commentId,i,'deep',0)"
                                        [ngClass]="{'liked': comment?.subComments[0]?.iLikedComment}"
                                        class="favColor pointer like-icon">{{comment?.subComments[0]?.iLikedComment
                                        ?
                                        'favorite' :'favorite_outlined'}}</mat-icon>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="comment?.showSubComments == true">
                            <div [@fadeUpAnimation] class="my-1"
                                *ngFor="let subComment of comment?.subComments; let y = index">
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex align-items-start">
                                        <!-- <img class="border-less-comments object-cover"
                                                [src]="app.getUserImage(subComment?.commentedByPicture)" alt="User Image"> -->

                                        <app-img-loader [className]="'commentCreator'"
                                            [src]="subComment?.commentedByPicture"></app-img-loader>

                                        <div class="mx-2 d-flex align-items-start">
                                            <div>
                                                <p class="m-0 CommentatorName">{{subComment?.commentedByName |
                                                    splitStringToArEn}}</p>
                                                <p class="m-0 posterSpech">{{subComment?.commentText}}</p>
                                                <p class="m-0 posterSpech">
                                                    <span
                                                        (click)="likesPopUp(subComment?.commentId,subComment?.likesCount,'comment')"
                                                        *ngIf="subComment?.likesCount != 0"
                                                        [ngClass]="{'mx-2': subComment?.likesCount != 0 }"
                                                        class="pointer">{{subComment?.likesCount | likeCount}}
                                                        {{ 'social.like' | translate }}</span>

                                                    <span class="replyP">{{subComment?.createdAt| relativeTime:
                                                        app?.languageCode}}</span>

                                                    <span *ngIf="subComment?.isMyComment || app?.IsSocialMediaManager"
                                                        (click)="deleteComment(subComment?.commentId,i,'deep',y)"
                                                        class="text-danger pointer mx-2">{{ 'social.delete' | translate
                                                        }}</span>
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                    <div>
                                        <mat-icon
                                            (click)="likeDislikeComment(subComment?.iLikedComment,subComment?.commentId,i,'deep',y)"
                                            [ngClass]="{'liked': subComment?.iLikedComment}"
                                            class="favColor pointer like-icon">{{subComment?.iLikedComment ?
                                            'favorite' :'favorite_outlined'}}</mat-icon>
                                    </div>
                                </div>
                            </div>
                            <!-- subCommentPaginator -->
                            <div class="d-flex justify-content-between">
                                <div>
                                    <p (click)="showMoreSubComments(comment?.subComments?.length,comment?.commentsCount,comment?.commentId,i)"
                                        class="showMoreP m-0">{{
                                        'social.showMoreSub' |
                                        translate }}</p>
                                </div>
                                <div>
                                    <p class="m-0 px-1">{{comment?.subComments?.length ?
                                        comment?.subComments?.length :
                                        0}} {{ 'social.of' |
                                        translate }}
                                        {{comment?.commentsCount}}</p>
                                </div>
                            </div>
                            <!-- subCommentPaginator -->
                        </div>

                        <div class="vlCss" [ngClass]="this.app?.getUserLanguage() == 'en' ? 'vlLeft' : 'vlRight'">
                        </div>

                        <!-- <div *ngIf="comment?.subComments?.length > 1">
                                <p (click)="subCommentsDialog(comment)" class="showMoreP m-0">{{ 'social.showMoreSub' |
                                    translate }}</p>
                            </div> -->

                    </div>
                    <!-- subCommentsSection -->

                </div>
                <!-- comment Section -->

                <!-- paginator&TypeComment -->
                <div class="mb-5" [@fadeUpAnimation]>
                    <!-- mainCommentsPaginator -->
                    <div class="px-3 d-flex justify-content-between" *ngIf="this.app.getUserData()">
                        <div>
                            <p (click)="showMoreMainComments(Comments?.length + 3)" class="showMoreP m-0">{{
                                'social.showMore' |
                                translate }}</p>
                        </div>
                        <div>
                            <p class="m-0 px-1">{{Comments?.length ? Comments?.length : 0}} {{ 'social.of' |
                                translate }}
                                {{mainCommentsTotalRow}}</p>
                        </div>
                    </div>
                    <!-- mainCommentsPaginator -->

                    <!-- addComment section -->
                    <div>
                        <div class="px-3 d-flex justify-content-between align-items-center">
                            <img class="border-less-comments" [src]="app.getUserImage(app?.getUserData()?.picture)"
                                alt="User Image">

                            <mat-form-field class="w-100 feedField h65 px-1" [dir]="this?.app?.getUserDire()"
                                appearance="outline">
                                <input [formControl]="mainComment" [placeholder]=" 'social.typeComment' | translate "
                                    type="text" matInput>
                                <mat-icon (click)="sendMainComment()" matSuffix class="sendIcon"
                                    [ngClass]="this.app?.getUserLanguage() == 'en' ? '' : 'rotate180'">send</mat-icon>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- addComment section -->
                </div>
                <!-- paginator&TypeComment -->
            </div>
        </div>
    </div>
</div>

<div *ngIf="app?.isPlatformServerVar"
    style="display: none !important;visibility:hidden !important;opacity: 0 !important;">
    <!-- <div style="display: none;visibility:hidden;opacity: 0;" *ngIf="router?.url?.includes('/en/')">
        <p>Future of Healthcare</p>
        <p>Search Doctor, Make an Appointment</p>
        <p>Discover the best doctors, clinic & hospital the city nearest to you.</p>
    </div> -->

    <div>
        <h2> {{ postDetails?.creatorName }}</h2>
        <h4> {{ postDetails?.creatorSpeciality }}</h4>
        <p> {{ postDetails?.createdAt }}</p>
        <h2> {{ postDetails?.postText }}</h2>
    </div>
</div>